import { cn } from '@/lib/utils';
import PricingCard, { PricingCardProps } from './PricingCard';
import ContactSales from './ContactSalesCard';
import { PricingCardsProps, PromoTextProps } from './PricingCards';
import { Product } from './product';
import { PricingCardContactSalesAttributes } from './PricingCardsStrapi';

export type PricingCardsDisplayProps = {
  getCardCtaSections: (
    pricingCard: PricingCardProps,
    contactSalesText: string
  ) => Partial<PricingCardProps>;
  cards: PricingCardsProps['cards'];
  cardLayout?: 'three_cols' | 'four_cols';
  hasDatacenterIpToggle: boolean;
  hasSpecialBadge: boolean;
  hasSelectedEnterprise: boolean;
  isSequentialSwitchShown: boolean;
  isResidentialProductType: boolean;
  promoText?: PromoTextProps;
  selectedProduct: Product;
  selectedControlledSalesCardToRender?: PricingCardContactSalesAttributes;
  texts: {
    pricing_cards: {
      contact_sales: string;
    };
  };
};

export const PricingCardsDisplay = ({
  getCardCtaSections,
  cards,
  cardLayout,
  hasDatacenterIpToggle,
  hasSpecialBadge,
  hasSelectedEnterprise,
  isSequentialSwitchShown,
  isResidentialProductType,
  promoText,
  selectedProduct,
  selectedControlledSalesCardToRender,
  texts,
}: PricingCardsDisplayProps) => {
  return (
    <div
      className={cn(
        hasDatacenterIpToggle ? '!mt-8' : '',
        (() => {
          if (hasSpecialBadge && hasSelectedEnterprise) return 'md:mt-7';
          if (
            hasSelectedEnterprise &&
            !hasSpecialBadge &&
            isSequentialSwitchShown
          )
            return 'md:mt-[40px]';
          if (
            hasSelectedEnterprise &&
            !hasSpecialBadge &&
            !isResidentialProductType
          )
            return 'md:mt-7';
          if (isSequentialSwitchShown) return 'md:mt-[40px]';
          if (promoText?.text) return 'md:mt-8';
          if (isResidentialProductType) return 'md:mt-8';
          return 'md:mt-[76px]';
        })(),
        selectedProduct === 'datacenter_ip' ? 'md:pt-[52px]' : '',
        cardLayout === 'four_cols'
          ? 'mt-9 grid grid-cols-1 items-end justify-center gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'
          : 'mx-auto lg:max-w-[1024px] mt-9 grid w-full grid-cols-1 items-end justify-center gap-4 md:mt-7 md:grid-cols-3 xl:grid-cols-3',
        cardLayout === 'four_cols' &&
          cardLayout === 'four_cols' &&
          cards.length === 1 &&
          'xl:grid-cols-2',
        cardLayout === 'four_cols' && cards.length === 2 && 'xl:grid-cols-3',
        cardLayout === 'four_cols' && cards.length > 3 && 'xl:grid-cols-4',
        cards.length > 2 ? 'w-full' : ''
      )}
    >
      {cards.map((pricing) => (
        <div className='h-max' key={pricing.pricingCard.id}>
          <PricingCard
            {...pricing.pricingCard}
            {...getCardCtaSections(
              pricing.pricingCard,
              texts.pricing_cards.contact_sales
            )}
          />
        </div>
      ))}
      {!!selectedControlledSalesCardToRender && (
        <ContactSales
          button={{
            ...(selectedControlledSalesCardToRender.button || {}),
            url: '#contact-sales',
          }}
          heading={selectedControlledSalesCardToRender.heading}
          description={selectedControlledSalesCardToRender.description}
          outlineColor={selectedControlledSalesCardToRender.outlineColor}
        />
      )}
    </div>
  );
};
